<template>
    <h4 class="font-bold text-gray-900 sm:pr-6">
        <slot></slot>
    </h4>
</template>
